import { Injectable } from '@angular/core';
import { StateFacade } from '@symphony-solo/domain/feature-states-aggregator/src';
import { TaxRateShiftsDto } from '@symphony-solo/domain/taxrate-shifts/src';
import { TaxrateDto } from '@symphony-solo/domain/taxrates/src';
import { roundDecimals } from '@symphony-solo/shared/utils/src';
import { find } from 'lodash';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { TransactionProduct, TransactionProductUnitPrice } from '../models';

@Injectable()
export class TaxCalculatorService {
  constructor(private stateFacade: StateFacade) {}

  public getProductTransactionWithTax(productTransaction: TransactionProduct, productTaxRateId: number): Observable<TransactionProduct> {
    return this.stateFacade.aggregatedState$.pipe(
      first(),
      map((state) => {
        const taxratesDictionary = state.taxratesFeature.taxrates;
        const taxrateShiftsDictionary = state.taxRateShiftsFeature.taxrateShifts;
        const selectedCustomerGroup = state.customerGroupsFeature.selectedCustomerGroup;
        const taxRateShiftId = selectedCustomerGroup.taxRateShift;
        const taxRateShift = taxrateShiftsDictionary[taxRateShiftId];
        const currentTaxRateId = this.findTaxRateShift(taxRateShift, productTaxRateId);
        const taxRate = taxratesDictionary[currentTaxRateId];
        const basePrice = this.extractBasePrice(taxRate, productTransaction.price);
        const taxAmount = this.roundTwoDecimals(productTransaction.price.value - basePrice.value);
        return { ...productTransaction, taxAmount, taxRate };
      })
    );
  }

  private extractBasePrice(taxrate: TaxrateDto, price: TransactionProductUnitPrice): TransactionProductUnitPrice {
    const roundedPrice = { ...price };
    roundedPrice.value = this.calculateBasePriceValue(price.value, taxrate.percent);
    return roundedPrice;
  }

  private roundTwoDecimals(amount: number): number {
    return roundDecimals(amount, 2);
  }

  private calculateBasePriceValue(priceValue: number, taxPercent: number): number {
    return (priceValue / (100 + taxPercent)) * 100;
  }

  private findTaxRateShift(taxRateShift: TaxRateShiftsDto, currentTaxRateId: number): number {
    if (taxRateShift) {
      const currentShift = find(taxRateShift.shifts, (shift) => shift.from === currentTaxRateId);
      if (currentShift) {
        return currentShift.to;
      }
    }
    return currentTaxRateId;
  }
}
